// extracted by mini-css-extract-plugin
export default {"container":"Container_container__P5Lf0","min-height":"Container_min-height__fzwLU"};